import { createContext } from 'react'
import usePageStayTime from '@/hooks/usePageStayTime'

const PageStayTimeContext = createContext(undefined)
// 创建 Provider 组件
export const PageStayTimeProvider = ({ children }) => {
  const pageStayTimeHook = usePageStayTime()
  return (
    <PageStayTimeContext.Provider value={pageStayTimeHook}>
      {children}
    </PageStayTimeContext.Provider>
  )
}
